import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms'
import { Router } from '@angular/router';

@Component({
  selector: 'app-forget-password',
  templateUrl: './confirm-password.component.html',
  styleUrls:  ['./confirm-password.component.css'] 
})
export class ConfirmPasswordComponent {

  constructor(private router: Router) { }

  // forgot() {
  //         this.router.navigate(['/useradded']);
  // }

  btnClick= function () {
    // this.router.navigateByUrl('/useradded');
};
}



// WEBPACK FOOTER //
// ./src/app/login/confirm-password.component.ts